<template>
    <div class="mask" v-show="show">
        <div class="con">
            <div v-show="showClose" class="close-confirm"></div>
            <div>
                <div class="con-title"> <span class="con-title-tip"></span>{{title}}</div>
                <p class="text" v-html="text"></p>
            </div>
            <div class="btn-con">
                <div class="btn cancel" v-show="cancelShow" @click="cancel">{{ cancelText }}</div>
                <div class="btn sure" v-show="confirmShow" @click="sure">{{ confirmText }}</div>
            </div>
        </div>
    </div>
</template>
<script>
/*
 * text支持html,
 * 用confirm-color类名强调文字
 */
const confirmText = '确定'
const cancelText = '取消'
export default {
    data () {
        return {
            text: '',
            title: '',
            confirmText,
            confirmShow: false,
            cancelShow: false,
            cancelText,
            show: false,
            showClose: true,
        }
    },
    methods: {
        init (options) {
            this.text = options.text
            this.confirmText = options.confirmText || confirmText
            this.cancelText = options.cancelText || cancelText
            const promise = new Promise((r, j) => {
                this.r = r
                this.j = j
            }).finally(() => {
                this.show = false
            })
            this.show = true
            return promise
        },
        sure () {
            this.r()
        },
        cancel () {
            console.log(this.j)
            this.j('确认弹窗取消')
        },
    },
}
</script>
<style lang="less" scoped>
.mask {
    position: fixed;
    z-index: 200;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;

    .con {
        width: 731px;
        min-height: 326px;
        max-height: 600px;
        //overflow-y: auto;
        //background: #EAEAEA;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: center;
        font-weight: 500;
        font-size: 22px;
        color: #808080;
        box-sizing: border-box;
        padding: 53px 40px 26px 40px;
        background-image: url('../../assets/images/confirm-bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        font-family: "微软雅黑";
        .close-confirm {
            position: absolute;
            right: -40px;
            top: 0;
            cursor: pointer;
            width: 30px;
            height: 30px;
            background-image: url("@/assets/images/close-confirm.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
        .con-title-tip {
            display: inline-block;
            width: 25px;
            height: 25px;
            background-image: url("@/assets/images/warm-tip.png");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            margin-right: 7px;
        }
        .con-title {
            text-align: left;
            margin-bottom: 20px;
            display: flex;
            align-items: center;
            font-size: 25px;
            font-family: Source Han Sans CN;
            font-weight: 800;
            color: #B0CAEB;
            line-height: 22px;
        }
        .text {
            margin-bottom: 65px;

            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #7289A6;
            line-height: 22px;
            text-align: left;

            ::v-deep .confirm-color {
                color: #FF7A1A;
                font-family: "微软雅黑";
            }
        }

        .btn-con {
            display: flex;
            justify-content: flex-end;
            align-items: center;

            .btn {
                width: 168px;
                height: 61px;
                font-weight: 500;
                font-size: 28px;
                line-height: 62px;
                color: #FFEFEF;
                margin-left: 10px;
                cursor: pointer;
            }
            .cancel {
                background-image: url("@/assets/images/cancel-btn.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
            }
            .sure {
                background-image: url("@/assets/images/confirm-btn.png");
                background-repeat: no-repeat;
                background-size: 100% 100%;
            }
        }
    }
}
</style>
